import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
  @Input() title: string = 'Confirm';
  @Input() message: string = 'Are you sure?';

  constructor(public activeModal: NgbActiveModal) {}


  ngOnInit(): void {
  }

  confirm() {
    this.activeModal.close('Confirmed');
  }

  cancel() {
    this.activeModal.dismiss('Canceled');
  }
}
